import type {SignInDto, User} from "~/types/user";
import Alert from "~/utils/Alert";
import LocalStorageUtil from "~/utils/localStorage";

export const useAuth = () => {
  const TOKEN_STORAGE_KEY = 'sr-auth'
  const cfx = {path: '/', watch: true};
  const jwt = useCookie(TOKEN_STORAGE_KEY, cfx)
  const user = useCookie<User | null>('sr-user', cfx)
  const teamUser = useCookie('sr-team-user', cfx)
  const userAdmId = useCookie('user-session-team-adm-id', cfx)
  const userAdmName = useCookie('user-session-team-adm-name', cfx)

  const config = useRuntimeConfig()
  const ready = ref<boolean>(false)

  const token = computed(() => {
    if (import.meta.server) {
      return jwt.value
    }
    const token = LocalStorageUtil.get(TOKEN_STORAGE_KEY)
    return token || jwt.value
  })

  const getBaseUrl = () => {
    if (import.meta.server) {
      return config.apiUrl
    }
    return config.public.apiUrl
  }

  const signIn = async (params: SignInDto): Promise<boolean> => {
    try {
      user.value = await $fetch<User>(getBaseUrl() + '/auth/login', {
        method: "POST",
        body: params,
        credentials: 'include'
      })
      LocalStorageUtil.set(TOKEN_STORAGE_KEY, user.value.token)
      return true;
    } catch (e: any) {
      user.value = null
      Alert.error('E-mail ou senha inválidos, tente novamente!')
    }
    return false
  }

  const getCurrentPath = () => {
    if (import.meta.client) {
      return window.location.pathname + window.location.search + window.location.hash
    } else {
      const route = useRoute()
      return route.fullPath
    }
  }

  const signOut = async () => {
    const currentPath = getCurrentPath()
    if (currentPath.includes("/?login=true")) return
    await $fetch(getBaseUrl() + '/auth/logout', {
      method: "POST",
      credentials: 'include'
    })
    user.value = null
    jwt.value = null
    teamUser.value = null
    userAdmId.value = null
    userAdmName.value = null
    LocalStorageUtil.remove(TOKEN_STORAGE_KEY)
    console.log("REDIRECT", currentPath)
    navigateTo(`/?login=true&redirect=${encodeURIComponent(currentPath)}`)
    return true;
  }

  const isAuthenticated = computed(() => user.value)

  const firstName = computed<string>((): string => {
    const names: string[] = (user.value?.name || '').split(' ')
    return names[0] || ''
  });

  const initialsForName = computed<string>(() => {
    const names: string[] = (user.value?.name || '').split(' ')
    if (names.length > 1) {
      return `${(names[0] || '').substring(0, 1)}${(names[1] || '').substring(0, 1)}`.toUpperCase()
    } else {
      return (user.value?.name || '   ').substring(0, 2).toUpperCase()
    }
  });

  return {
    signIn,
    signOut,
    token,
    user,
    ready,
    firstName,
    initialsForName,
    isAuthenticated
  }
}
